(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tm-commerce-foundation"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeCommerce = (scope = document) => {
      scope.querySelectorAll('[data-tm-commerce-root]').forEach((root) => {
        if (root.dataset.tmCommerceReady === 'true') return;
        root.dataset.tmCommerceReady = 'true';

        root.querySelectorAll('[data-tm-auto-submit]').forEach((control) => {
          control.addEventListener('change', () => control.form?.requestSubmit());
        });

        root.querySelectorAll('[data-tm-dialog-open]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const dialog = root.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
            dialog?.showModal();
          });
        });

        root.querySelectorAll('[data-tm-dialog-close]').forEach((trigger) => {
          trigger.addEventListener('click', () => trigger.closest('dialog')?.close());
        });

        root.querySelectorAll('.tm-commerce__dialog').forEach((dialog) => {
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
        });
      });
    };

    initializeCommerce();
    document.addEventListener('shopify:section:load', (event) => initializeCommerce(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tm-home-foundation"] && !Shopify.designMode) return;
  try {
    const revealPassedMeridianSections = () => {
    document.querySelectorAll('.tm-home-reveal-ready:not(.tm-home-reveal-visible)').forEach((section) => {
      if (section.getBoundingClientRect().top < window.innerHeight * 0.92) {
        section.classList.add('tm-home-reveal-visible');
      }
    });
  };

  const initializeMeridianReveals = (root = document) => {
    const sections = root.querySelectorAll('.tm-home-section, .tm-benefits');
    if (!sections.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('tm-home-reveal-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    sections.forEach((section) => {
      if (section.classList.contains('tm-home-reveal-ready')) return;
      section.classList.add('tm-home-reveal-ready');
      observer.observe(section);
    });

    revealPassedMeridianSections();
  };

  initializeMeridianReveals();
  document.addEventListener('shopify:section:load', (event) => initializeMeridianReveals(event.target));

  if (!window.meridianRevealScrollReady) {
    window.meridianRevealScrollReady = true;
    let revealFramePending = false;

    window.addEventListener('scroll', () => {
      if (revealFramePending) return;
      revealFramePending = true;
      requestAnimationFrame(() => {
        revealPassedMeridianSections();
        revealFramePending = false;
      });
    }, { passive: true });
  }
  } catch(e) { console.error(e); }
})();

})();
